<template>

   <TopBanner layout="full-width" currentPage="Forget Password" heading="Forget Password" bannerClass="banner-auth" />
   <div class="flex flex-col gap-12 py-24 px-11 lg:w-theme-dw md:mx-auto md:px-0">
      <div class="flex flex-col md:flex-row items-center bg-theme-gray-7 px-12 py-10 gap-6">
         <div class="relative bg-white rounded-full min-w-[50px] min-h-[50px] flex flex-row items-center justify-center">
            <span class="font-icon theme-icon info-icon text-theme-active absolute -top-[23px] -left-[13px] text-[47px]"></span>
         </div>
         <div class="flex flex-col gap-3">
            <h4 class="font-bold text-size-6 text-theme-gray-5">Information</h4>
            <p class="font-light text-size-6 text-theme-gray-4">Lost your password? Please enter your username or email address. You will receive a link to create a new password via email.</p>
         </div>
      </div>
      <div class="flex flex-col w-full lg:w-theme-auth mx-auto gap-5">
         <div class="flex flex-col gap-2">
            <label for="login-username" class="uppercase text-small text-theme-gray-4">Username or email address *</label>
            <div class="flex flex-row items-center border border-theme-gray-7">
               <input v-model="email" type="text" id="login-username" class="w-full outline-none text-theme-gray-5 p-2 h-[40px] md:h-[55px] font-bold text-size-4 md:text-size-6">
            </div>
         </div>
         <div class="flex flex-row items-center gap-4">
            <div @click="handleResetPassword" :class="isLoading ? 'cursor-not-allowed opacity-40' : 'cursor-pointer hover:text-theme-active hover:bg-white'" class="order-1 md:order-2 gap-4 uppercase rounded-full w-full md:w-auto px-4 md:px-8 py-2 md:py-4 border-2 border-theme-active text-white bg-theme-active text-theme-gray-2 text-size-2 flex items-center justify-center ml-auto transition-all ease-in-out duration-500">
               Reset password
            </div>
         </div>
      </div>
   </div>
   <Notification :show="notif.show" :type="notif.type" :message="notif.message" :messageDetails="notif.messageDetails" @closed="notifClosed"/>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import TopBanner from '@/components/TopBanner.vue'
import Auth from '@/composables/Auth'
import { handleApiError } from '@/utils/common'
import { NotificationType } from '@/types'
import Notification from '@/widgets/Notification.vue'

const email = ref<string>('')
const isLoading = ref<boolean>(false) 
const { forgetPassword }  = Auth()
const notif = ref<NotificationType>({ show: false, type: 'success', message: '', messageDetails: ''})

const handleResetPassword = async () => {

   if (email.value != '' && !isLoading.value) {

      isLoading.value = true
      const response = await forgetPassword(email.value)
      isLoading.value = false
      
      if (response.status == 200) {
         notif.value = { show: true, type: 'success', message: 'Email Sent', messageDetails: 'An email has been sent at your provided address'}
         resetForm()
      } else {
         const error = handleApiError(response)
         notif.value = { show: true, type: 'error', message: error, messageDetails: ''}
         setTimeout(() => { notifClosed() }, 4000)
      }
   }
}

const resetForm = () :void => {
   email.value = ''
}

const notifClosed = () => {
   notif.value.show = false
}

</script>